import { SelectFilterOption } from '../types';
import { archivedLabel } from './archived';

interface MasterDataItem {
  name: string;
  position?: number | null;
  isArchived?: boolean | null;
}

/**
 * Select-filter options from master data (Auswahlfelder, Länder), ordered by
 * `position` (unset last), then name.
 */
export function toMasterDataFilterOptions(
  items: readonly MasterDataItem[] | null | undefined,
): SelectFilterOption[] {
  if (!items) return [];
  return [...items]
    .sort(
      (a, b) =>
        (a.position ?? Infinity) - (b.position ?? Infinity) ||
        a.name.localeCompare(b.name, 'de'),
    )
    .map(({ name, isArchived }) => ({
      label: isArchived ? archivedLabel(name) : name,
      value: name,
    }));
}

export function groupByFieldName<T extends { fieldName: string }>(
  items: readonly T[] | null | undefined,
): Partial<Record<string, T[]>> {
  const groups: Partial<Record<string, T[]>> = {};
  for (const item of items ?? []) {
    (groups[item.fieldName] ??= []).push(item);
  }
  return groups;
}

/**
 * Flags options missing from `usedValues` `unused: true`, present ones
 * `unused: false`; without `usedValues` (not loaded yet) the flag stays unset.
 */
export function markUsedFilterOptions(
  options: readonly SelectFilterOption[],
  usedValues: readonly string[] | undefined,
): SelectFilterOption[] {
  if (!usedValues) return [...options];
  const used = new Set(usedValues);
  return options.map((option) => ({
    ...option,
    unused: !used.has(option.value),
  }));
}
